import { useState } from 'react'
import { addPlayer } from '../api';

/**
 * CreateLogin Component
 *
 * Component with create login form.
 *
 * @returns {JSX.Element}
 * @constructor
 */
const CreateLogin = () => {
  const [errorMsg, setErrorMsg] = useState('');

  /**
   * onCreateLogin
   *
   * Handler for when the create login button is clicked.
   *
   * @param event
   * @returns {Promise<void>}
   */
  const onCreateLogin = async (event) => {
    const displayName = document.querySelector('#displayName').value;
    const email = document.querySelector('#email').value;
    const password = document.querySelector('#password').value;

    if (displayName && email && password) {
      try {
        // TODO: Validate email and apply min password requirements

        const player = JSON.parse(localStorage.getItem('player'));

        const newPlayer = await addPlayer({
          temp_id: player.temp_id ?? undefined,
          email: email,
          name: displayName,
          password: password,
          groups: player.groups ?? []
        });

        if (newPlayer !== null) {
          // Save player in local storage
          localStorage.setItem('player', JSON.stringify(newPlayer));

          // Redirect to dashboard page
          window.location = '/dashboard';
        }
      } catch (err) {
        console.log('Error creating new player: ', err);
        if (err.response) {
          setErrorMsg(err.response.data.error);
        } else if (err.message) {
          setErrorMsg(err.message);
        }
      }
    } else {
      setErrorMsg('Please enter a value for all fields.');
    }
  }

  /**
   * onSkipClick
   *
   * Handler for when the skip button is clicked.
   * TODO: Move visibility to a param
   *
   * @returns {Promise<void>}
   */
  const onSkipClick = async () => {
    // Redirect to stats page
    window.location = '/dashboard';
  }

  return (
    <div className="login-wrap">
      <div className="invite-code-label">Create Login</div>
      <div className="new-login-copy">Create a login to save your games and avoid repeat questions.</div>
      <div className="input-label-wrap">
        <div className="input-label">Display Name</div>
      </div>
      <input id="displayName" className="input" type="text"/>
      <div className="input-label-wrap">
        <div className="input-label">Email</div>
      </div>
      <input id="email" className="input" type="email"/>
      <div className="input-label-wrap">
        <div className="input-label input-label-password">Password</div>
      </div>
      <input id="password" className="input" type="password"/>
      <div className="error-msg">{errorMsg}</div>
      <button className="main-btn signup-btn" onClick={onCreateLogin}>Have Fun!</button>
      {window.location.pathname !== '/dashboard' &&
        <button className="link-button skip-link" onClick={onSkipClick}>Skip</button>
      }
    </div>
  )
}

export default CreateLogin
